/** src/lang/eu/messages.js */
const messages = {
  // ==================== HEADER & NAVIGATION ====================
  'dashboard': 'Dashboard',
  'logout': 'Logout',
  'statistics': 'Statistics',
  'reporting': 'Reporting',
  'download': 'Download',
  'dashboard_logo': 'Dashboard Logo',
  'tyre_data' : 'Tyre List',
  // ==================== TYRE MANAGEMENT ====================
  'new_tyre_entry': 'New Tyre Entry',
  'daily_task': 'Daily Task',
  'tyre_removal': 'Tyre Removal',
  'tyre_repair': 'Tyre Repair',
  'tyre_fitment': 'Tyre Fitment',
  'tyre_history': 'Tyre History',
  'tyre_daily_task': 'Tyre Daily Task',
  'type': 'Type',
  'repair_life': 'Repair Life',
  'repaired_life': 'Repair Life',
  'count': 'Count',
  //=======================Repair Management ====================
  'add_damage_detail': 'Add Damage Detail',
  'add_image': 'Add Image',
  'uploaded_images': 'Uploaded Images',
  'upload_image': 'Upload Image',
  'choose_file': 'Choose File',
  'no_file_chosen': 'No File Chosen',
  'damage_detail': 'Damage Detail',
  'repair_data': 'Repair Data',
  'confirm_delete_image_message': 'Are you sure you want to delete this image? This action cannot be undone.',
  'please_select_cut_number': 'Please select Reference Cut Number',
  'please_select_remark': 'Please select a remark',
  'please_select_image': 'Please select Image',
  'please_fill_all_fields': 'Please fill all required fields!',
  'exceed_of_cuts': 'Exceed of cuts!',
  'damage_added_successfully': 'Damage added successfully',
  'damage_updated_successfully': 'Damage update successfully',
  'damage_deleted_successfully': 'Damage deleted successfully',
  'damage_update_failed': 'Damage Not updated!',
  'invalid_data': 'Invalid data to update. Missing ID!',
  'number_of_cut_inserted_completed': 'Faild! Number Of Cut Inserted Completed!!',
  'please_fill_no_of_cut': 'Please fill Number of Cut field!',
  'repair_delete_failed': 'Failed to delete the repair entry.',
  // ==================== TYRE DETAILS ====================
  's_no': 'Sr. no.',
  'tyre_number': 'Tyre number',
  'tyre_make': 'Tyre make',
  'tyre_type': 'Tyre type (Pattern)',
  'tyre_size': 'Tyre size',
  'tyre_status': 'Tyre status',
  'current_status': 'Current status',
  'otd': 'OTD (Original thread depth)',
  'enter_otd': 'OTD (Original thread depth)',
  'otl': 'OTL (Original tyre life)',
  'rtd_a': 'RTD A (mm)',
  'rtd_a_wear': 'RTD A (%) Wear',
  'rtd_b': 'RTD B (mm)',
  'rtd_b_wear': 'RTD B (%) wear',
  'avg_tread_depth': 'Avg. tread depth (mm)',
  'avg_tread_wear': 'Avg. tread (%) wear',
  'wear_rate': 'Wear rate (Km./mm)',
  'ptl': 'PTL (KM.)',
  'life': 'Life',
  'affected_balance_tread': 'Affected tread depth',
  'balance_ptl': 'Balance PTL',
  'total_ptl': 'Total PTL',
  'tyre_current_status': 'Tyre current status',
  'of': 'Of',
  'requirement_month': 'Requirement month',
  'requirement_days': 'Requirement days',
  'enter_tyre_number': 'Enter Tyre Number',
  'enter_fitment_kmr': 'Enter Fitment KMR',
  'enter_purchase_order_no': 'Enter Purchase Order No.',
  'enter_po_number': 'Enter Purchase Order No.',
  'enter_machine_number': 'Enter Machine Number',
  // ==================== VEHICLE/MACHINE ====================
  'machine_make': 'Machine make',
  'machine_model': 'Machine model',
  'machine_number': 'Machine number',
  'vehicle_make': 'Machine make',
  'vehicle_model': 'Machine model',
  'vehicle_number': 'Machine number',
  'truck_make': 'Machine make',
  'truck_model': 'Machine model',
  'truck_number': 'Machine number',
  'truck_number': 'Machine number',
  'position_type': 'Position type',
  'position': 'Position',
  'change_position': 'Change position',
  'same_machine': 'Same machine',
  'other_machine': 'Other machine',
  'fitment_in': 'Fitment In',

  // ==================== KILOMETERS & DATES ====================
  'fitment_kmr': 'Fitment KMR',
  'kilometers_reading': 'Kilometers reading (KMR)',
  'kilometer_covered_current': 'Kilometer covered in current machine',
  'kilometer_covered_previous': 'Kilometer covered in previous machine',
  'first_fitment_date': 'First fitment date',
  'purchase_date': 'Purchase date',
  'from_period': 'From date',
  'to_period': 'To date',
  'current_kmr': 'Current KMR',
  'current_hmr': 'Current KMR',
  'previous_machine_km': 'Previous machine Km.',
  'current_machine_km': 'Current machine Km.',
  'current_life': 'Current life',
  'log_book_reading': 'Log book reading',
  'lbsr': 'LBSR',
  'km_cicm': 'Kilometer covered in current machine',
  'km_cipm': 'Kilometer covered in previous machine',
  'hcicm': 'Kilometer covered in current machine',
  'hcipm': 'Kilometer covered in previous machine',
  // ==================== REPORTS ====================
  'generate_pdf': 'Generate PDF',
  'export_excel': 'Export excel',
  'export': 'Export',
  'fitment_report': 'Fitment report',
  'removal_report': 'Removal report',
  'removal_data': 'Removal data',
  'repair_history': 'Repair history',
  'scrap_tyre_report': 'Scrap tyre report',
  'running_tyre_life': 'Running tyre life',
  'running_tyre_average_life': 'Running tyre average life - chart View',
  'tyre_average_life_statistics': 'Tyre average life statistics',
  'tyre_requirement_plan': 'TYRE REQUIREMENT PLAN',
  'tyre_stock': 'Tyre stock',
  'tyre_stock_report': 'Tyre stock',
  'stock': 'Stock',
  'total_stock': 'Total stock',
  'requirement_plan': 'Requirement plan',
  'downloading': 'Downloading...',
  'download_excel': 'Download to excel',
  'repaired_date': 'Repaired date',
  'repair_status': 'Repair status',
  'tyre_total_life': 'Tyre total life',
  'date': 'Date',
  'service_date': 'Service date',
  'cut_no': 'Cut number',
  'cut_number': 'Cut number',
  'patch_no': 'Patch number',
  'before_repair': 'Before repair',
  'after_repair': 'After repair',
  'please_login': 'Please login to download reports',
  'download_success': 'Excel downloaded successfully!',
  'server_error': 'Server error occurred. Please try again.',
  'no_response': 'No response from server. Please check your connection.',
  'download_failed': 'Failed to download excel file. Please try again.',
  'repair': 'Repair',
  'six_month_forecast': '6-MONTH TYRE REQUIREMENT FORECAST',
  'six_month_forecast_chart': '6-Month Requirement Forecast',
  'monthly_requirement_summary': 'Monthly Requirement Summary',
  'entries': 'Entries',
  'month_year': 'Month-Year',
  'required_quantity': 'Required quantity',
  'no_data_available': 'No data available for selected filters',
  'total_requirement': 'Total requirement',
  'avg_per_month_label': 'Average per month',
  'forecast_info': 'Forecast shows tyre requirements for the next 6 months starting from',
  'tyres': 'tyres',
  'sizes': 'Sizes',
  'months': 'Months',
  'avg_per_month': 'Avg',
  'month': 'month',
  'tyre_count': 'Tyre Count',
  'no_chart_data': 'No chart data available for selected filters',
  'size_name': 'Tyre size',
  'scrap_count': 'Scrap count',
  'repair_count': 'Repairs',
  'repair_dates': 'Repair date',
  'repair_date': 'Repair date',
  'kmcipm': 'Km.CIPM',
  'kmcicm': 'Km.CICM',
  'scrap_reason': 'Scrap reason',
  'tyre_size_make': 'Tyre size & make',
  'entries': 'entries',
  'search_history': 'Search history',
  'select_tyre_to_search': 'Select a tyre number to search',
  'use_search_box_above_tyre': 'Use the search box above to find tyre history',
  'please_select_tyre': 'Please select a tyre number',
  'site_selected': 'Site selected',
  'loading_sites': 'Loading sites...',
  'reset_success': 'Filters reset successfully!',
  'loading_data': 'Loading data...',
  'log_book_reading': 'Log book reading',
  'success': 'Success',
  'tyre_stock_details': 'Tyre stock details',
  'quantity_with_status': 'Quantity with status',
  'total_tyre': 'Total tyre',
  'no_status_data': 'No status data',
  'view_all_details': 'View all details',
  'new_tyre_in_stock': 'New tyre in stock',
  'all_descriptions': 'All descriptions',
  'description': 'Description',
  'pressure' : 'Pressure',
  'view': 'View',
  'details': 'details',
  'all': 'All',
  'previous_rtd_a': 'Previous RTD-A',
  'previous_rtd_b': 'Previous RTD-B',
  'previous_kmr': 'Previous KMR',
  'image_details': 'Image details',

  // ==================== STATISTICS ====================
  'number_of_projects': 'Number of project',
  'total_spare_tyres': 'Total spare tyres',
  'total_running_tyres': 'Total running tyres',
  'number_of_tyres': 'Number of tyres',
  'total_new_tyres': 'Total new tyres',
  'total_scrap': 'Total scrap',
  'total_removal': 'Total removal',
  'total_repair': 'Total repair',
  'total_life': 'Total Life:',
  'avg_life': 'Avg life:',
  'total_tyres': 'Total tyres:',
  'average_life': 'Average life',
  'number_of_regular_tyres': 'Number of regular tyres',
  'number_of_cph_tyres': 'Number Of CPH Tyres',
  'average_life_statistics': 'Average life statistics',
  'last_fitment_date': 'Last fitment date',
  'last_removal_date': 'Last removal date',
  'current_life': 'Current life',
  'view_history_details': 'View tyre history details',

  // ==================== FILTERS ====================
  'filters': 'Filters',
  'requirement_plan_filters': 'Requirement Plan Filters',
  'stock_filters': 'Stock Filters',
  'average_life_filters': 'Average Life Filters',
  'select': 'Select',
  'select_site': 'Select Site',
  'select_project': 'Select Project(s)',
  'select_tyre_make': 'Select Tyre Make(s)',
  'select_tyre_size': 'Select Tyre Size(s)',
  'select_status': 'Select status',
  'site': 'Site',
  'projects': 'Projects',
  'all_sites': 'All sites:',
  'project': 'Project',
  // ==================== FORMS & BUTTONS ====================
  'add': 'Add',
  'edit': 'Edit',
  'update': 'Update',
  'delete': 'Delete',
  'save': 'Save',
  'cancel': 'Cancel',
  'reset': 'Reset',
  'search': 'Search',
  'enter': 'Enter',
  'submit': 'Submit',
  'close': 'Close',
  'previous': 'Previous',
  'next': 'Next',
  'view_details': 'View Details',
  'upload': 'Upload',
  'in': 'In',
  'on': 'On',
  'at': 'At',
  'showing': 'Showing',
  'rows': 'Rows',
  'records': 'Records',
  'total': 'Total',
  'page': 'page',

  // ==================== VIEWS ====================
  'analysis': 'Analysis',
  'graph_view': 'Graph View',
  'table_view': 'Table View',
  'month': 'Month',
  'monthly': 'Monthly',
  'forecast': 'Forecast',
  'quantity': 'Quantity',

  // ==================== ISSUES ====================
  'raise_issues_list': 'Raise Issues List',
  'raise_new_issue': 'Raise New Issue',
  'search_by_subject': 'Search by subject/message',
  'new_tyre_entry_not_saved': 'new tyre entry is not getting saved',
  'no_image': 'No Image',
  'open': 'Open',
  'message': 'Message',
  'detailed_message': 'Detailed message of the issue',
  'attachments': 'Attachments',
  'choose_files': 'Choose files',
  'max_file_size': 'Max file size: 2MB. Supported formats: .png, .jpg, .pdf, .docx.',
  'remarks': 'Remarks',
  'add_remarks': 'Add remarks',
  'status': 'Status',
  'open_status': 'Open',
  'in_progress': 'In progress',
  'closed': 'Closed',
  'submit_issue': 'Submit Issue',
  'action': 'Action',

  // ==================== MESSAGES ====================
  'record_saved': 'Record saved successfully',
  'record_updated': 'Record updated successfully',
  'record_deleted': 'Record deleted successfully',
  'error_occurred': 'An error occurred',
  'no_records_found': 'No records found',
  'no_chart_data': 'No chart data available',
  'no_data_found': 'No Data Found',
  'no_data_selected_filters': 'No data available for the selected filters',
  'select_site_project_first': 'Select Site and Project first to see available sizes',
  'future_projection': 'Future projection based on current data',

  // ==================== LANGUAGE ====================
  'select_language': 'Select Language',
  'english': 'English',
  'russian': 'Russian',

  // ==================== MONTHS ====================
  'january': 'January',
  'february': 'February',
  'march': 'March',
  'april': 'April',
  'may': 'May',
  'june': 'June',
  'july': 'July',
  'august': 'August',
  'september': 'September',
  'october': 'October',
  'november': 'November',
  'december': 'December',

  // ==================== MISC ====================
  'po_number': 'PO number',
  'type_make': 'Type make',
  'service': 'Service',
  'data': 'Data',
  'damage': 'Damage',
  'number_of_cut': 'Number of cut',
  'no_of_cut': 'Number of cut',
  'number_of_patch': 'Number of patch',
  'no_of_patch': 'Number of patch',
  'cut_location': 'Cut location',
  'actual_cut_location': 'Actual cut location',
  'actual_location': 'Actual cut location',
  'ntc_tc_cut': 'NTC & TC cut',
  'cut_length': 'Cut length',
  'cut_width': 'Cut width',
  'cut_depth': 'Cut depth',
  'patch_number': 'Patch number',
  'list': 'List',
  'image': 'Image',
  'remark': 'Remark',
  'information': 'Information',
  'hours': 'hrs',
  'requirement': 'Requirement',
  'total_requirement': 'Total requirement',
  'damage_list': 'Damage List',
  // ==================== EXCEL HEADERS ====================
  'excel_tyre_number': 'Tyre number',
  'excel_tyre_make': 'Tyre make',
  'excel_tyre_size': 'Tyre size',
  'excel_vehicle_number': 'Vehicle number',
  'excel_machine_number': 'Machine number',
  'excel_status': 'Status',
  'excel_purchase_date': 'Purchase date',
  'excel_fitment_date': 'Fitment date',
  'excel_removal_date': 'Removal date',
  'excel_current_location': 'Current location',
  'excel_brand': 'Brand',
  'excel_model': 'Model',
  'excel_position': 'Position',
  'excel_life': 'Life',
  'excel_total_life': 'Total life',

  // ==================== NAVIGATION TITLES ====================
  'nav_dashboard': 'Dashboard',
  'nav_new_tyre': 'New Tyre Entry',
  'nav_daily_task': 'Daily Task',
  'nav_removal': 'Tyre Removal',
  'nav_repair': 'Tyre Repair',
  'nav_fitment': 'Tyre Fitment',
  'nav_reporting': 'Reporting',
  'nav_history': 'Tyre History',
  'nav_fitment_report': 'Fitment Report',
  'nav_removal_report': 'Removal Report',
  'nav_repair_report': 'Repair Report',
  'nav_scrap_report': 'Scrap Report',
  'nav_running_tyre': 'Running Tyre Life',
  'nav_avg_life': 'Average Life',
  'nav_requirement': 'Requirement Plan',
  'nav_tyre_scrap': 'Repair Rejected & Scrap',
  'nav_tyre_scrap_report': 'Scrap Tyre',
  'nav_stock': 'Stock',
  'nav_tyre_stock_report': 'Tyre Stock',
  'nav_issues': 'Issues',
  'profile': 'Profile',
  'manual': 'Manual',
  'download_manual': 'Download Manual',
  'nav_new_tyre_report': 'New Tyre Running Report',
  'cph_inventory': 'CPH Inventory',
  'item_category': 'Item Category',
  'item_stocks': 'Item Stocks',
  'item_used': 'Item Used',
  'purchase_tyre_entry': 'Purchase Tyre Entry',
  'purchase_other_items': 'Purchase Other Items',
  'cph_reporting': 'CPH Reporting',
  'cph_tyre_history': 'CPH Tyre History',
  'stocks_report': 'Stocks Report',
  'purchase_report': 'Purchase Report',
  'used_item_report': 'Used Item Report',
  'manage_site': 'Manage Site',
  'site_entry': 'Site Entry',
  'site_project': 'Site Project',
  'manage_user': 'Manage User',
  'user_entry': 'User Entry',
  'manage_customer': 'Manage Customer',
  'customer_entry': 'Customer Entry',
  'master_entry': 'Master Entry',
  'excel_import_tyre': 'Excel import Tyre',
  'excel_import': 'Excel import',
  'removal_reason_category': 'Removal Reason Category',
  'change_email': 'Change Email',
  'change_password': 'Change Password',
  'setting': 'Setting',
  'download_ids': 'DownloadIDS',
  'tyre_status_category': 'Tyre Status Category',
  'tyre_scrap': 'Tyre Scrap',
  'tyre_life_report': 'Tyre Life Report',
  'type_of_wear': 'Type Of Wear',
  'used_tyre_type': 'Used Tyre type',
  'manage_tyre_position': 'Manage Tyre Position',
  'manage_cut_location': 'Manage Cut Location',
  'manage_accurate_location': 'Manage Accurate Location',

  // Add these at the end of the file, before export default messages;

  // ==================== CUSTOMER DASHBOARD ====================
  'customer_dashboard': 'Customer Dashboard',
  'welcome_to_tyre_management': 'Welcome to Tyre Management System',
  'your_comprehensive_solution': 'Your comprehensive solution for tyre lifecycle management',
  'home_select_a_report_message': 'Select a report from the menu to view detailed information',
  'select_report_from_menu': 'Select a report from the menu to view detailed information',
  'select_atleast_one_site_for_search': 'Please select at least one site to view report',
  'select_atleast_one_site': 'Please select at least one site',
  'over_all_removal': 'Over All Removal',
  'over_all_fitment': 'Over All fitment',
  'all_size': 'All Size',
  'all_make': 'All Tyre Make',
  'all_project': 'All Project',
  'select_site_and_click_search': 'Select a site from the dropdown above and click Search',
  'loading_report': 'Loading reports...',
  'loading': 'Loading...',
  'surya_kiran_group': 'Surya Kiran Group',
  'pavlik': 'Pavlik',
  'pavlik_mines': 'Pavlik Mines',
  'report_type:': 'Report Type:',

  // ==================== FILTERS ====================
  'all_projects': 'All Projects',
  'all_makes': 'All Makes',
  'all_sizes': 'All Sizes',
  'all_status': 'All Status',
  'all_sites': 'All Sites',
  'select_site_first': 'Select Site and Project first to see available sizes',
  'please_select_site': 'Please select at least one site',
  'select_site_from_dropdown': 'Select a site from the dropdown above and click Search',
  'click_search_to_view': 'Click Search to view data',
  'select_filters_and_search': 'Select your filters and click the Search button to see results',
  'no_data_found_try_adjusting': 'No data found. Try adjusting your filters to see more results',
  'search_filters': 'Search Filters',
  'no_filters': 'No filters',
  'no_filter_found': 'No data found',
  'not_selected': 'Not Selected',
  'period': 'Period',
  'to': 'to',

  // ==================== STATISTICS ====================
  'total_tyres': 'Total Tyres',
  'total_life_sum': 'Total Life',
  'avg_life_km': 'Avg Life (Km.)',
  'chart_view': 'Chart View',
  'tabular_view': 'Tabular View',
  'records_count': 'Records',

  // ==================== TYRE STOCK ====================
  'tyre_stock_report': 'Tyre Stock Report',
  'stock_details': 'Stock Details',
  'available_stock': 'Available Stock',
  'location': 'Location',
  'current_location': 'Current Location',

  // ==================== SCRAP REPORT ====================
  'scrap_report': 'Scrap Report',
  'scrap_reason': 'Scrap Reason',
  'scrap_date': 'Scrap Date',
  'tyre_scrap_report': 'Tyre Scrap Report',

  // ==================== REQUIREMENT PLAN ====================
  'requirement_plan_report': 'Requirement Plan Report',
  'monthly_requirement': 'Monthly Requirement',
  'yearly_requirement': 'Yearly Requirement',
  'projected_requirement': 'Projected Requirement',

  // ==================== TYRE HISTORY ====================
  'tyre_history_report': 'Tyre History Report',
  'life_cycle_history': 'Life Cycle History',
  'tyre_life_cycle': 'Tyre Life Cycle',
  'installation_history': 'Installation History',
  'removal_history': 'Removal History',
  'repair_history': 'Repair History',

  // ==================== MACHINE HISTORY ====================
  'machine_history_report': 'Machine History Report',
  'machine_no': 'Machine Number',
  'tyre_history_by_machine': 'Tyre History by Machine No.',

  // ==================== NEW TYRE RUNNING ====================
  'new_tyre_running_report': 'New Tyre Running Report',
  'new_tyre_used': 'New Tyre Used',
  'running_tyres': 'Running Tyres',

  // ==================== FITMENT REPORT ====================
  'fitment_report_details': 'Fitment Report Details',
  'fitment_date': 'Fitment Date',
  'fitment_details': 'Fitment Details',
  'kmr_at_fitment': 'KMR at Fitment',

  // ==================== REMOVAL REPORT ====================
  'removal_report_details': 'Removal Report Details',
  'removal_date': 'Removal Date',
  'removal_details': 'Removal Details',
  'kmr_at_removal': 'KMR at Removal',

  // ==================== TYRE LIFE REPORT ====================
  'tyre_life_report_details': 'Tyre Life Report Details',
  'life_details': 'Life Details',
  'total_life_km': 'Total Life (Km.)',

  // ==================== MODAL ====================
  'view_details_modal': 'View Details',
  'close_modal': 'Close',
  'tyre_details': 'Tyre Details',
  'history_details': 'History Details',

  // ==================== BUTTONS ====================
  'download_report': 'Download Report',
  'generate_report': 'Generate Report',
  'apply_filters': 'Apply Filters',
  'clear_filters': 'Clear Filters',
  'view_report': 'View Report',
  'export_report': 'Export Report',
  'print_report': 'Print Report',

  // =====================Search Tab and Inner Tab=============================
  'over_all_fitment': 'Over All Fitment',
  'repaired_fitted': 'Repaired Fitted',
  'search_by_po_no': 'Search By PO Number',
  'search_by_tyre_no': 'Search By Tyre Number',
  'search_by_machine_no': 'Search by machine no.',
  'search_truck_history': 'Search truck history',
  'select_truck_number': 'Search or select truck number…',
  'select_po_no': 'Select Purchase Order Number',
  'select_tyre_number': 'Select Tyre Number',

  'select_machine_no': 'Select Machine No',
  'loading_truck_numbers': 'Loading truck numbers...',
  'no_truck_numbers_found': 'No truck numbers found',
  'please_select_truck': 'Please select a truck number',
  'please_select_truck_first': 'Please select a truck number first',
  'no_data_to_export': 'No data to export. Please search first.',
  'truck': 'Truck',
  'total_records': 'Total Records',
  'select_truck_to_search': 'Select a truck number to search',
  'use_search_box_above': 'Use the search box above to find truck history',
  'view_history_details': 'View Tyre History Details',
  'excel': 'Excel',
  'total_life_km': 'Total Life (Km.)',
  //==============================================================
  'po_selected': 'PO selected',
  'tyre_selected': 'Tyre selected',
  'searching': 'Searching...',
  'selected': 'Selected',
  // ==========Positions====================
  'fr': 'Front Right',
  'fl': 'Front Left',
  'rli': 'Rear Left Inner',
  'rlo': 'Rear Left Outer',
  'rri': 'Rear Right Inner',
  'rro': 'Rear Right Outer',
  'rr': 'Rear Right',
  'rl': 'Rear Left',
  'front': 'Front',
  'rear': 'Rear',

  // ==================== TYRE CONDITIONS (Status) ====================
  'running': 'Running',
  'scrap': 'Scrap',
  'replaced': 'Replaced',
  'removed_for_repair': 'Removed for repair',
  'remove_for_repair': 'Removed for repair',
  'for_new_spare': 'For new spare',
  'spare': 'Spare',
  'fleet_maintenance': 'Fleet Maintenance',
  'rotation': 'Rotation',
  'tube_puncture': 'Tube puncture',
  'from_other_mine': 'From other Mine',
  'repaired': 'Repaired',
  'removed': 'Removed',
  // ==================== Types ====================
  'removal': 'Removal',
  'fitment': 'Fitment',
  'routine_task': 'Routine task',
  'daily_task_data': 'Routine task data',
  'repair_rejected_scrap': 'Repair Rejected & Scrap',
  'scrap_data': 'Scrap Data',
  // ==================== REMOVAL REASONS ====================
  'removal_reason': 'Removal Reason',
  'all_reasons': 'All reasons',
  'air_separation': 'Air separation',
  'bead_damage': 'Bead damage',
  'beyond_repair_center': 'Beyond repair center',
  'beyond_repair_shoulder': 'Beyond repair shoulder',
  'beyond_repair_side_wall': 'Beyond repair Side-Wall',
  'burst_blow_out': 'Burst/Blow out',
  'other': 'Other',
  'scrap_due_to_bead_exposed': 'Scrap due to bead exposed',
  'worn_out': 'Worn-out',
  'for_repair': 'For Repair',
  'beyond_repair': 'Beyond Repair',
  'side_change': 'Side Change',
  'meter_change': 'Meter Change',
  'scrap_due_to_ply_exposed': 'Scrap Due To Ply Exposed',
  'remove_for_replaced': 'Remove For Replaced',
  'remove_for_fleet_maintenance': 'Remove for Fleet Maintenance',
  'repair_rejected': 'Repair Rejected',
  //==================Report Title======================================
  'tyre_information': 'TYRE INFORMATION',
  'tyre_performance_history': 'TYRE PERFORMANCE HISTORY',
  'summary': 'SUMMARY',
  //================= Repair Cut Translation ===========================
  'side_wall': 'Side Wall',
  'tread_area': 'Tread Area',
  'shoulder': 'Shoulder',
  'bead_area': 'Bead Area',
  // 'bead_damage' : 'Bead Damage',
  'air_pocket': 'Air Pocket',
  'bulging': 'Bulging',
  'separation': 'Separation',
  'burst_impact': 'Burst-Impact',
  'impact_external_object': 'Impact-External Object',
  'manufacturing_defect': 'Manufacturing Defect',
  // 'worn_out' : 'Worn Out',
  'pin_hole': 'PIN Hole',
  'deep_cut': 'Deep cut',
  'through_cut': 'Through cut',
  'non_through_cut': 'Non-through cut',
  //================= Tyre Condition ===========================
  'tyre_condition_critical': 'Is tyre condition critical?',
  'critical_type': 'Critical type',
  'is_critical': 'Is critical?',
  'full_worn_out': 'Full worn out',
  'risk_repair': 'Risk repair',
  'fitment_in': 'Fitment In',
  'select_status_first': 'Select Status First',
  //============================================
  'yes': 'Yes',
  'no': 'No',
  'select_critical_type': 'Select Critical Type',
  'please_select_critical_type': 'Please select a critical type',
  'critical': 'Critical',
  // ==================== PERMISSION MESSAGES ====================
  'no_permission_add': "You don't have Add permission for this page.",
  'no_permission_update': "You don't have Update permission for this page.",
  'no_permission_delete': "You don't have delete permission for this page.",
  'no_permission_view': "No permission to view this page.",
  'no_item_selected': "No item selected for update",
  'record_not_found': "Record not found!",
  'please_fill_fields': "Please fill in the following fields:",
  'must_be_greater_than_previous': "must be greater than previous KMR",
  'cannot_be_empty': "cannot be empty!",
  'save_failed': "Failed to save record!",
  'update_failed': "Failed to update record!",
  'delete_failed': "Failed to delete record!",
  'confirm_delete': "Are you sure you want to delete this record?",
  'updating': "Updating...",
  'saving': "Saving...",
  // ==================== ADDITIONAL TRANSLATIONS FOR TYRE HISTORY REPORT ====================
  'cph_tyre_history': 'CPH Tyre History',
  'search_by_site_name': 'Search By Site',
  'search_by_date': 'Search By Date',
  'search_by_site_project': 'Search By Project',
  'search_by_tyre_make': 'Search By Tyre Make',
  'business_types': 'Business Type',
  'regular': 'Regular',
  'cph': 'CPH',
  'select_site_project': 'Select Project',
  'total_repair_life': 'Total Repair Life',
  //=====================Statistics===============================//
  'statistics': 'Statistics',
  'total_running': 'Total Running',
  'total_removed': 'Total Removed',
  'total_remove_for_repair': 'Total Remove for Repair',
  'total_repaired': 'Total Repaired',
  'total_spare': 'Total Spare',
  'total_critical_tyres': 'Total Critical Tyres',
  'total_scrap': 'Total Scrap',
  'new_tyre_in_stock' : 'New Tyres in Stock',
  'critical_tyre_report': 'Critical Tyre Report',
};

export default messages;